import React from "react"
import BookingCard from "./BookingCard"

export default function BookingList({ bookings }) {
  return (
    <div className="vt-trip-bookings">
      {bookings?.map((booking, idx) => {
        return (
          <BookingCard
            index={idx}
            key={booking?.id || `b-${idx}`}
            booking={booking}
          ></BookingCard>
        )
      })}
    </div>
  )
}
